<template>
   <el-form class="form-box"  ref="form" :model="convForm"  :rules="convRules" label-width="100px">
        <el-row>
          <el-col :span="7" >
             <el-form-item label="竞价目标">
              <el-radio-group v-model="target" size="mini" @change="(value)=>$emit('formchange', value)">
                <el-radio-button 
                  v-for="item in targetList"
                  :label="item.value"
                  :key="item.value"
                >
                  {{item.label}}
                </el-radio-button>
              </el-radio-group>
             </el-form-item>
          </el-col>
          <el-col :span="7" >
            <el-form-item label="计费方式" required>
              <el-radio-group @change="triggerPriceTip" :value="way" size="mini" @input="(data)=>$emit('update:way', data)" >
                <el-radio-button 
                  v-for="item in wayList" 
                  :key="item" 
                  :label="item"
                />
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="深度转化">
              <el-switch
                active-value="1"
                inactive-value="0"
                v-model="convForm.deepConv"
                @change="handleDeepConvChange"
                >
              </el-switch>
            </el-form-item>
          </el-col>
          
        </el-row>
        <el-row>
          <el-col :span="7" >
             <el-form-item label="跟踪类型" prop="follType">
              <ESelect 
                style="width:150px"
                v-model="convForm.follType" 
                clearable 
                @change="handleRestFollTypeChange"
              >
                  <el-option 
                    v-for="item in trackingTypeList" 
                    :key="item.tracking_type"
                    :value="item.tracking_type" 
                    :label="item.tracking_type_name"
                  />
                </ESelect>
             </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="转化类型" prop="convType">
              <el-cascader
                style="width:150px" 
                popper-class="conv-type-popper"
                v-model="convForm.convType"
                :disabled="!convForm.follType"
                :placeholder="convForm.follType?'请选择':'请选择跟踪类型'"
                :options="convTypeOptions"
                :show-all-levels="false"
                :props="{ expandTrigger: 'hover' }"
                @change="(v)=>handleConvTypeChange(v, triggerPriceTip()) "
                clearable>
              </el-cascader>
            </el-form-item>
            
          </el-col>
          <el-col :span="7" v-if="convForm.deepConv !=='0'">
            <el-form-item label="深度转化目标" prop="convTarget">
              <el-cascader
                style="width:150px" 
                popper-class="conv-type-popper"
                v-model="convForm.convTarget"
                :disabled="!convForm.convType?.length"
                :placeholder="convForm.convType?.length?'请选择':'请选择转化类型'"
                :options="deepConvOptions"
                :show-all-levels="false"
                :props="{ expandTrigger: 'hover' }"
                clearable>
              </el-cascader>
            </el-form-item>
            
          </el-col>
         
       <!-- </el-row>
        <el-row>  -->
            <el-col :span="7">
              <el-form-item label="一阶段出价" prop="price_1">
                <el-input  
                  style="width:150px" 
                  v-model="convForm.price_1" 
                  placeholder="请输入一阶段出价"
                  @input="(v)=>handleValidNumber(v,'price_1', 'cpx_bid')"
                />
              </el-form-item>
              <div class="form-item__tip" v-if="showPrice_1Tip">
                <TipInfo :data="priceAvg"/>
              </div>
            </el-col>
            <el-col :span="7">
              <el-form-item label="二阶段出价" prop="price_2">
                <el-input 
                  style="width:150px" 
                  v-model="convForm.price_2" 
                  @input="(v)=>handleValidNumber(v,'price_2', 'ocpx_bid')"
                  placeholder="请输入二阶段出价"
                />
              </el-form-item>
              <div class="form-item__tip" v-if="showPrice_2Tip">
                <TipInfo :data="ocpxPriceAvg"/>
              </div>
            </el-col>
             <el-col :span="7" v-if="convForm.deepConv  !=='0'">
              <el-form-item label="三阶段出价" prop="deep_price">
                <el-input 
                  style="width:150px" 
                  v-model="convForm.deep_price" 
                  placeholder="请输入三阶段出价"
                   @input="(v)=>validDeepNumber(v)"
                  
                />
              </el-form-item>
            </el-col>
        </el-row>
        <div :class="addType === 1? 'name-box':''">
           <template v-if="addType === 1">
              <span style="color: #606266"><i style="color: #F56C6C">*</i> 转化名称</span>
              <el-row :gutter="20" style="margin-top: 10px" v-if="convForm.follType&&convForm.convType.length">
                <el-col 
                  :span="12"
                   v-for="item in appList"
                  :key="item.app_id" 
                >
                  <el-form-item
                  >
                    <template slot="label">
                      <div class="form_label">
                        <span class="ellipsis form_label_text" :title="item.app_name">{{item.app_name}}</span>
                        <p>{{item.app_id}}</p>
                      </div>
                    </template>
                    <ConversionName
                      v-model="nameData[item.app_id]"
                      :appId="item.app_id"
                      :follType='convForm.follType'
                      :convType='convForm.convType'
                    />
                  </el-form-item>
                  
                </el-col>
              </el-row>
              <template v-else>
                <span class="text-color-gray pl8">请先选择跟踪类型与转化类型</span>
              </template>
              <div class="mt10"/>
             <template v-if="convForm.deepConv  !=='0'">
               <span style="color: #606266"><i style="color: #F56C6C">*</i> 深度转化名称</span>
                <el-row :gutter="20" style="margin-top: 10px" v-if="convForm.follType&&convForm.convTarget?.length">
                  <el-col 
                    :span="12"
                    v-for="item in appList"
                    :key="item.app_id" 
                  >
                    <el-form-item
                    >
                      <template slot="label">
                        <div class="form_label">
                          <span class="ellipsis form_label_text" :title="item.app_name">{{item.app_name}}</span>
                          <p>{{item.app_id}}</p>
                        </div>
                      </template>
                      <ConversionName
                        v-model="deepNameData[item.app_id]"
                        :appId="item.app_id"
                        :follType='convForm.follType'
                        :convType='convForm.convType'
                        :isDeep="true"
                        :convTargetData='convForm.convTarget'
                      />
                    </el-form-item>
                    
                  </el-col>
                </el-row>
                <template v-else>
                  <span class="text-color-gray pl8">请先选择跟踪类型与转化类型</span>
                </template>
              </template>
           </template>
           <template v-else>
            <el-form-item
              required
              label="转化名称"
            >
              <ConversionName
                style="width: 425px"
                v-model="convForm.name"
                :addType='addType'
                :follType='convForm.follType'
                :convType='convForm.convType'
              />
            </el-form-item>
             <el-form-item
              v-if="convForm.deepConv  !=='0'"
              required
              label="深度转化名称"
            >
              <ConversionName
                style="width: 425px"
                v-model="convForm.deepName"
                :addType='addType'
                :follType='convForm.follType'
                :convType='convForm.convType'
                 :isDeep="true"
                :convTargetData='convForm.convTarget'
              />
            </el-form-item>
           </template>
        </div>
      </el-form>
</template>

<script>
import { validNum } from '@/utils/validate'
import TipInfo from './tipInfo.vue'
import ConversionName from './conversionName.vue'
export default {
  components: { TipInfo, ConversionName },
  props: ['dTarget', 'formData', 'targetList','way', 'conversionPriceData', 'wayList', 'validNumber', 'addType'],
  inject: ['getTrackingType', 'getTypeData', 'getFormParams', 'getPackageType', 'appList'],
  provide() {
    return {
      getTypeNameData: (...arg)=>this.getTypeNameDataFn(...arg),
      getDeepTypeNameData: (...arg)=>this.getDeepTypeNameDataFn(...arg),
    }
  },
  data() {
    const validateNum =  (key,rule, value, callback) => {
        if (validNum(value)) {
          if (value>=0.01&&value<5000) {
            callback()
          }else {
             this[key] = false;
             callback(new Error('请输入大于等于0.01和小于5千的数'))
          }
        }else {
          this[key] = false;
          callback(new Error('请输入非负数字'))
        }
      };
    const { 
        follType='', convType="", price_1=0.1, 
        price_2='', name="", deep_price='', 
        deepConv ='0',
        convTarget="", deepName=''
      } = this.formData;
      const formatStr = (str)=> {
        const list = str.split(':');
          let data = [];
          if (list.length === 1&&str) {
            data = list
          }else {
            if (str) {
              data = [list[0],str]
            }
          }
          return data
      }
   const validateDeepNum = (rule, value, callback)=> {
       if (validNum(value)) {
        console.log(value, 'valuevaluevalue');
        
          if (value>=0.01&&value<100) {
            callback()
          }else {
             callback(new Error('请输入大于等于0.01和小于100的数'))
          }
        }else {
          callback(new Error('请输入非负数字'))
        }
   }
    return {
      loading: false,
      priceAvg: '',//一阶段
      ocpxPriceAvg: '',//二阶段
      target: this.dTarget,
      showPrice_1Tip: false,
      showPrice_2Tip: false,
      trackingTypeList: this.getTrackingType(),//跟踪类型
      convForm: {
        follType,
        convType: [...formatStr(convType)],
        price_1,
        price_2,
        name ,
        deepName,
        deep_price,
        deepConv,
        convTarget: [...formatStr(convTarget)],
      },
      convTypeOptions: [],//转化类型
      deepConvOptions: [],//深度转化目标
      conversionNameList: [],//转化名称
      convRules: {
        // blur
        follType: [
          { required: true, message: '请选择跟踪类型', trigger: 'change' },
        ],
        convType: [
          { required: true, message: '请选择转化类型', trigger: 'change' },
        ],
        convTarget: [
          { required: true, message: '请选择转化目标', trigger: 'change' },
        ],
        
        price_1: [
          {required: true, validator: (...arg)=>validateNum('showPrice_1Tip',...arg), trigger: 'change' }
        ],
        price_2: [
          { required: true,validator: (...arg)=>validateNum('showPrice_2Tip',...arg), trigger: 'change' }
        ],
        deep_price: [
          { required: true, validator: validateDeepNum, trigger: 'change' }
        ],
        
      },
      appIdObj: {},
      outTime: null,
      deepAppIdObj: {},
      outDeepTime: null,
      nameData: {},//存放转化名称的字段
      deepNameData: {},//存深度转化名称的字段
    }
  },
  watch: {
    convForm: {
      handler(n) {
        this.$emit('updateForm', {
          ...n,
          convType: [...n.convType].pop() || '',
          convTarget: [...n.convTarget].pop() || '',
        });
      },
      immediate: true,
      deep: true
    },
    'convForm.convType'(n) {
      this.$emit('update:avgData', null)
    }
    
  },
  created() {
    this.$nextTick(()=> {
      if (this.convForm.follType) {
        this.handleFollTypeChange(this.convForm.follType)
      }
      if (this.convForm.convType.length) {
        this.handleConvTypeChange(this.convForm.convType)
      }
    })
  },
 
  methods: {
    validDeepNumber(value) {
      const num = this.validNumber(value);
      if (num) {
        this.convForm.deep_price = num;
      }
    },
    handleDeepConvChange(value) {
      const convType = this.convForm.convType?.length
      if (value !=='0' && convType) {
        this.getDeepConvData([...this.convForm.convType].pop())
      }else {
        this.deepConvOptions = [];
        this.deep_price = ''//三阶段
        this.convForm.convTarget = [];
      }
    },
    handleValidNumber(value, key, type) {
      const num = this.validNumber(value);
       this.handleShowTip(num || value, type)
      if (num) {
        this.convForm[key] = num
      }
    },
    handleRestFollTypeChange(tracking_type) {
      this.convForm.name = '';
      this.convForm.convType = [];
      this.convForm.convTarget = [];
      this.convTypeOptions = [];
      this.deepConvOptions = [];
      // this.convForm.priceAvg = ''//一阶段
      // this.convForm.ocpxPriceAvg = ''//二阶段
      // this.convForm.deep_price = ''//三阶段
      
      if (tracking_type) {
        this.handleFollTypeChange(tracking_type)
      }
    },
    
    // 获取转化名称
    handleConvTypeChange(conversion_type) {
      const type = [...conversion_type].pop();
      if (!type) {
        this.priceAvg = ''//一阶段
        this.ocpxPriceAvg = ''//二阶段
        return;
      };
      this.getDeepConvData(type)
    },
    getDeepConvData(conversion_type) {
      if (this.convForm.deepConv ==='0') {
        return
      }
       this.loading = true
        const params = {
          conversion_type,
          tracking_type: this.convForm.follType,
          deep_conversion: '1',
        }
        function getOptionData(data=[]) {
          return data.map(v=>{
            return {
              value: v.union_conversion_type,
              label: v.union_conversion_type_name,
              children: v.key_action_types?.length? getOptionData(v.key_action_types):undefined
            }
          })
        }
        this.getTypeData(({ conversion_type })=> {
          this.loading = false
          this.deepConvOptions = getOptionData(conversion_type)
        },params)
    },
    // 获取转化类型
    handleFollTypeChange(tracking_type) {
      
      this.loading = true
      const params = {
        tracking_type
      }
      function getOptionData(data=[]) {
        return data.map(v=>{
          return {
            value: v.union_conversion_type,
            label: v.union_conversion_type_name,
            children: v.key_action_types?.length? getOptionData(v.key_action_types):undefined
          }
        })
      }
      this.getTypeData(({ conversion_type })=> {
        this.loading = false
        this.convTypeOptions = getOptionData(conversion_type)
      },params)
    },
    // 显示均价提示
    async handleShowTip(value, key) {
      if ( !(this.convForm.follType && this.convForm.convType.length)) {
         this.$refs.form.validateField(['follType','convType']);
         return
      }
      if (value&&validNum(value)&&value>=0.01&&value<5000) {
        const params = {
            type: key,
            tracking_type: this.convForm.follType,
            conversion_type: this.convForm.convType[0],
            value
        }
        if (key === 'cpx_bid') {
             this.showPrice_1Tip = true
            this.priceAvg = ''
          }else {
            this.ocpxPriceAvg = ''
            this.showPrice_2Tip = true
          }
        this.conversionPriceData(params, (data)=> {
          if (key === 'cpx_bid') {
            this.priceAvg = data
          }else {
            this.ocpxPriceAvg = data
          }
        })
       
      }else {
        if (key === 'cpx_bid') {
             this.showPrice_1Tip = false
          }else {
            this.showPrice_2Tip = false
          }
      }
    },
    triggerPriceTip() {
      this.handleShowTip(this.convForm.price_1,'cpx_bid')
      this.handleShowTip(this.convForm.price_2,'ocpx_bid')
    },
    getDeepTypeNameDataFn(fn, params) {
      this.outDeepTime&&clearTimeout(this.outDeepTime);
      this.deepAppIdObj[`${params.app_id}_${params.isDeep}`] = fn;
      
      this.outDeepTime = setTimeout(()=> {
        const app_id = Object.keys(this.deepAppIdObj).filter(v=> !!this.deepAppIdObj[v]);
        this.getTypeData(({conversion_name})=> {
          const data = conversion_name.reduce((pre, item)=> {
            pre[item.app_id] = item;
           return pre
          }, {});
          app_id.map(v=> {
            this.deepAppIdObj[v]&&this.deepAppIdObj[v](data[v.split('_')[0]])
            this.deepAppIdObj[v] = undefined
          })
        }, {
          ...params,
          app_id: app_id.map(v=>v.split('_')[0])
        })
      }, 100)
    },
    // 中间层  减少数据请求
    getTypeNameDataFn(fn, params) {
      this.outTime&&clearTimeout(this.outTime);
      this.appIdObj[`${params.app_id}_${params.isDeep}`] = fn;
      
      this.outTime = setTimeout(()=> {
        const app_id = Object.keys(this.appIdObj).filter(v=> !!this.appIdObj[v]);
        this.getTypeData(({conversion_name})=> {
          const data = conversion_name.reduce((pre, item)=> {
            pre[item.app_id] = item;
           return pre
          }, {});
          app_id.map(v=> {
            this.appIdObj[v]&&this.appIdObj[v](data[v.split('_')[0]])
            this.appIdObj[v] = undefined
          })
        }, {
          ...params,
          app_id: app_id.map(v=>v.split('_')[0])
        })
      }, 100)
    }
  }
}
</script>
<style>
.conv-type-popper .el-scrollbar__wrap {
  height: 204px;
}
</style>
<style lang="scss" scoped>
.form-box {
  &::v-deep {
    .el-col {
      height: 51px;
    }
  }
}
  .form_label {
    line-height: 1;
    padding-top: 6px;
    text-align: left;
  }
  .form_label_text {
    display: inline-block;
    width: 100%;
  }
  .name-box {
    border: 1px solid #ccc;
    border-radius: 5px;
    margin: 0 10px;
    padding: 12px 18px;
  }
 .form-item__tip {
     margin-top: -16px;
    margin-left: 28px;
    color: #666;
    font-size: 12px;
 }
</style>